<template>
    <relatorio-page :titulo=" 'Relatório Fluxo Bancário' " :cabecalhoCompleto="true" :exportarExcel="exportarExcel" :paisagem="true">
        
        <v-row>
            <v-col cols="12">
                <span>Período dos lançamentos: {{new Date(filter.dataInicial).ddmmyyyy()}} até {{new Date(filter.dataFinal).ddmmyyyy()}}</span> <br/>
                <span> Banco: {{banco? banco.nome : ''}}</span>
            </v-col>
        </v-row>       

        <!-- PADRAO -->
        <v-simple-table v-if="filter.layoutId == 1" id="tabela" dense class="py-2 text-caption">
            <template v-slot: default>
                <thead style="background-color: #4A70A8">
                    <tr class="fonte">
                        <th style="font-size: 100% ; color: white" class="text-left">Código</th>
                        <th style="font-size: 100% ; color: white" class="text-center">Nome</th>
                        <th style="font-size: 100% ; color: white" class="text-center">Lançamento</th>
                        <th style="font-size: 100% ; color: white" class="text-center">Data</th>
                        <th style="font-size: 100% ; color: white" class="text-center">Cheque</th>
                        <th style="font-size: 100% ; color: white" class="text-left">Entrada</th>
                        <th style="font-size: 100% ; color: white" class="text-left">Saída</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="fonte" v-for="(item, index) in item.items" :key="index" :style=" index % 2 === 0 ? 'background-color: gainsboro' : 'background-color: White'">
                        <td style="font-size: 100%" class="text-left">{{item.idFluxoBancario}}</td>
                        <td style="font-size: 100%" class="text-left">{{item.tipo == "D" ? item.fornecedor : item.tipo == "R" ? item.doador : ''}}</td>
                        <td style="font-size: 100%" class="text-left">{{item.descricao}}</td>
                        <td style="font-size: 100%" class="text-left">{{item.data ? new Date(item.data).ddmmyyyy() : ''}}</td>
                        <td style="font-size: 100%" class="text-left">{{item.numeroCheque}}</td>
                        <td style="font-size: 100%" class="text-right">{{item.credito.toMoeda(true)}}</td>
                        <td style="font-size: 100%" class="text-right">{{item.debito.toMoeda(true)}}</td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>

        <!-- ATIVIDADES -->
        <v-simple-table v-else id="tabela" dense class="py-2 text-caption">
            <template v-slot: default>
                <thead style="background-color: #4A70A8">
                    <tr class="fonte">
                        <th style="font-size: 100% ; color: white" class="text-left">Código</th>
                        <th style="font-size: 100% ; color: white" class="text-center">Data Pgto</th>
                        <th style="font-size: 100% ; color: white" class="text-center">Mês / Ano Competência</th>
                        <th style="font-size: 100% ; color: white" class="text-center">Nome</th>
                        <th style="font-size: 100% ; color: white" class="text-center">Atividade</th>
                        <th style="font-size: 100% ; color: white" class="text-center">Sub-atividade</th>
                        <th style="font-size: 100% ; color: white" class="text-center">Lançamento</th>
                        <th style="font-size: 100% ; color: white" class="text-center">Documento</th>
                        <th style="font-size: 100% ; color: white" class="text-center">Entrada</th>
                        <th style="font-size: 100% ; color: white" class="text-center">Saída</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="fonte" v-for="(item, index) in item.items" :key="index" :style=" index % 2 === 0 ? 'background-color: gainsboro' : 'background-color: White'">
                        <td style="font-size: 100%" class="text-left">{{item.idFluxoBancario}}</td>
                        <td style="font-size: 100%" class="text-left">{{item.data ? new Date(item.data).ddmmyyyy() : ''}}</td>                        
                        <td style="font-size: 100%" class="text-center" v-if="item.tipo == 'D'">{{item.compromissoCompetencia ? new Date(item.compromissoCompetencia).mmyyyy() : ''}}</td>
                        <td style="font-size: 100%" class="text-center" v-else>{{item.financeiroCompetencia ? new Date(item.financeiroCompetencia).mmyyyy() : ''}}</td>
                        <td style="font-size: 100%" class="text-left">{{item.tipo == "D" ? item.fornecedor : item.tipo == "R" ? item.doador : ''}}</td>                        
                        <td style="font-size: 100%" class="text-left">{{item.compromissoAtividade}}</td>
                        <td style="font-size: 100%" class="text-left">{{item.compromissoAtividadeItem}}</td>
                        <td style="font-size: 100%" class="text-left">{{item.descricao}}</td>
                        <td style="font-size: 100%" class="text-center" v-if="item.tipo == 'D'">{{item.numeroDocumento}}</td>
                        <td style="font-size: 100%" class="text-left" v-else></td>
                        <td style="font-size: 100%" class="text-right">{{item.credito.toMoeda(true)}}</td>
                        <td style="font-size: 100%" class="text-right">{{item.debito.toMoeda(true)}}</td>
                    </tr>
                    <tr class="fonte">
                        <td></td>
                        <td class="px-0 text-right" style="font-size: 100%; width: 100px !important; height: 50px !important;">Saldo Inicial:</td>
                        <td class="px-1 text-left" style="font-size: 100%; width: 100px !important; height: 50px !important;">{{item.saldoInicial? item.saldoInicial.toMoeda(true) : "R$ 0"}}</td>
                        <td class="px-0 text-right" style="font-size: 100%; width: 100px !important; height: 50px !important;">Saldo Final:</td>
                        <td class="px-1 text-left" style="font-size: 100%; width: 100px !important; height: 50px !important;">{{item.saldoAtual? item.saldoAtual.toMoeda(true) : "R$ 0"}}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td class="px-1 text-right" style="font-size: 100%; width: 100px !important; height: 50px !important;">{{item.totalEntrada? item.totalEntrada.toMoeda(true) : "R$ 0"}}</td>
                        <td class="px-1 text-right" style="font-size: 100%; width: 100px !important; height: 50px !important;">{{item.totalSaida? item.totalSaida.toMoeda(true) : "R$ 0"}}</td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>

        <v-row v-if="filter.layoutId == 1">
            <v-col cols="3">
                <span>Saldo Inicial: {{item.saldoInicial? item.saldoInicial.toMoeda(true) : "R$ 0"}}</span>
            </v-col>
            <v-col cols="3">
                <span>Total Entrada: {{item.totalEntrada? item.totalEntrada.toMoeda(true) : "R$ 0"}}</span>
            </v-col>
            <v-col cols="3">
                <span>Total Saída: {{item.totalSaida? item.totalSaida.toMoeda(true) : "R$ 0"}}</span>
            </v-col>
            <v-col cols="3">
                <span>Saldo Final: {{item.saldoAtual? item.saldoAtual.toMoeda(true) : "R$ 0"}}</span>
            </v-col>
        </v-row>

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </relatorio-page>
</template>

<script>
import FluxoBancarioService from '@/core/services/financeiro/FluxoBancarioService';
import FornecedorService from "../../../core/services/financeiro/FornecedorService"
import BancoService from '../../../core/services/financeiro/BancoService';
import Banco from '../../../core/domain/financeiro/Banco';

export default {
    
    data: () => ({
        item:{
            required: true
        },
        filter: {},
        service: new FluxoBancarioService(),
        bancoService: new BancoService(),
        overlay: false,
        banco: new Banco(),
        exportarExcel: false
    }),
    props:{

    },
    mounted(){
        this.filter = this.$route.query;

        this.overlay = true;

        if(this.filter.layoutId == 1)
            this.exportarExcel = false;
        else
            this.exportarExcel = true;

        this.service.ListarComFiltro(this.filter).then(
            res=>{
                this.item = res.data;
            },
            err => {
                this.$swal('Aviso', err.response.data.title ? err.response.data.title : err.response.data, 'error')
            },
            
        ).finally(() => {
            this.overlay = false;
        })

        this.bancoService.ObterPorId(this.filter.bancoId).then(
            res=>{
                this.banco = res.data
            },
            err => this.$swal('Aviso', err.response.data, 'error')
        )
    },
    methods:{
        
    }   

}
</script>

<style>
    .fonte{
        font-size: 70% !important;
    }
</style>